import { useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface IRequireAuth {
  children: React.ReactChild;
  redirectTo: string;
}

interface IProtectedRoute {
  element: React.ReactElement;
}

const ProtectedRoute: React.FC<IProtectedRoute> = ({ element }) => {
  return (
    <RequireAuth redirectTo="/">
      <>{element}</>
    </RequireAuth>
  );
};
const RequireAuth: React.FC<IRequireAuth> = ({ children, redirectTo }) => {
  const authState = useAppSelector(selectAuth);
  const location = useLocation();
  return authState.authenticated ? (
    <> {children} </>
  ) : (
    <Navigate to={redirectTo} state={{ from: location }} />
  );
};
export default ProtectedRoute;
